import { FC, ReactElement } from 'react';

import { SpaceDetailRenderer } from '../../../containers';
import { useTypedSelector } from '../../../redux/store';

interface ConnectedSpaceDetailRendererProps {
    className?: string;
}

export const ConnectedSpaceDetailRenderer: FC<ConnectedSpaceDetailRendererProps> = ({
    className = '',
}): ReactElement => {
    const isLoading = useTypedSelector(state => state.spaceSlice.isLoading);
    const space = useTypedSelector(state => state.spaceSlice.space);
    const categories = useTypedSelector(state => state.spaceSlice.categories);
    const breadcrumbs = useTypedSelector(state => state.spaceSlice.breadcrumbs);

    return (
        <SpaceDetailRenderer
            showSlider={categories.length > 0}
            isLoading={isLoading}
            space={space}
            breadcrumbs={breadcrumbs}
            categories={categories}
            className={className}
        />
    );
};
